import { Select } from 'foundations-components/transitional/components/Select';
import { ChartTypeToggleOptionComponent, SelectedChartTypeToggleOptionComponent } from './ChartTypeToggleItemComponents';
import { jsx as _jsx } from "react/jsx-runtime";
const ChartTypeSelect = ({
  value,
  options,
  onChange,
  ['data-test-id']: dataTestId = 'chart-type-toggle'
}) => {
  return /*#__PURE__*/_jsx(Select, {
    "data-test-id": dataTestId,
    buttonUse: "transparent",
    menuWidth: "auto",
    options: options,
    itemComponent: ChartTypeToggleOptionComponent,
    valueComponent: SelectedChartTypeToggleOptionComponent,
    value: value,
    onChange: onChange,
    padding: "0"
  });
};
export default ChartTypeSelect;